export default "__VITE_ASSET__8411f623__"